import { render, staticRenderFns } from "./ApprovedRepeatedClientModal.vue?vue&type=template&id=fdd0ace2&scoped=true&"
import script from "./ApprovedRepeatedClientModal.vue?vue&type=script&lang=js&"
export * from "./ApprovedRepeatedClientModal.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedRepeatedClientModal.vue?vue&type=style&index=0&id=fdd0ace2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd0ace2",
  null
  
)

export default component.exports